/* eslint-disable @typescript-eslint/no-explicit-any */
import tw, { css, styled } from 'twin.macro'

import { ExclamationCircle } from '../Icons'
import {
  errorIconBasicStyles,
  inputErrorStyles,
  inputSlotBasicStyles,
  inputStyles,
  inputWrapperErrorStyles,
  inputWrapperStyles,
} from '../sharedStyles'

type StyledProps = {
  $hasError?: any
  $hasStartSlot?: any
  $hasEndSlot?: any
  $disabled?: boolean
}

export const InputWrapper = styled.div(
  ({ $hasError, $disabled }: StyledProps) => [
    ...inputWrapperStyles,
    $disabled && tw`bg-default-muted`,
    $hasError && inputWrapperErrorStyles,
  ],
)

export const StyledInput = styled.input(
  ({ $hasError, $hasStartSlot, $hasEndSlot }: StyledProps) => [
    inputStyles,
    $hasError && inputErrorStyles,
    $hasStartSlot && tw`rounded-l-none pl-0`,
    $hasEndSlot && tw`rounded-r-none pr-0`,
    css`
      &[type='number'] {
        -moz-appearance: textfield;
      }

      &[type='search']::-webkit-search-cancel-button,
      &[type='search']::-webkit-search-decoration {
        -webkit-appearance: none;
        appearance: none;
      }
    `,
  ],
)

export const InputSlot = styled.div<{
  $content: any
}>(({ $content }) => [
  inputSlotBasicStyles,
  typeof $content === 'string' &&
    tw`select-none pointer-events-none font-functional`,
])

export const ErrorIcon = styled(ExclamationCircle)(
  ({ $hasEndSlot }: StyledProps) => [
    errorIconBasicStyles,
    $hasEndSlot && tw`mr-3`,
  ],
)
